import { css } from 'styled-components';
const GilroyFontFaces = css `
    /* Gilroy - Normal */
    @font-face {
        font-family: 'Gilroy';
        src: url('/fonts/Gilroy-Regular.otf') format('opentype');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Gilroy';
        src: url('/fonts/Gilroy-SemiBold.otf') format('opentype');
        font-weight: 600;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Gilroy';
        src: url('/fonts/Gilroy-Bold.otf') format('opentype');
        font-weight: Bold;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Gilroy';
        src: url('/fonts/Gilroy-ExtraBold.otf') format('opentype');
        font-weight: 800;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Gilroy';
        src: url('/fonts/Gilroy-Medium.otf') format('opentype');
        font-weight: 500;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Gilroy';
        src: url('/fonts/Gilroy-Light.otf') format('opentype');
        font-weight: 200;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Gilroy';
        src: url('/fonts/Gilroy-UltraLight.otf') format('opentype');
        font-weight: lighter;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'Gilroy';
        src: url('/fonts/Gilroy-Thin.otf') format('opentype');
        font-weight: 100;
        font-style: normal;
        font-display: swap;
    }

    /* Gilroy - Italic */

    @font-face {
        font-family: 'Gilroy';
        src: url('/fonts/Gilroy-RegularItalic.otf') format('opentype');
        font-weight: normal;
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: 'Gilroy';
        src: url('/fonts/Gilroy-SemiBoldItalic.otf') format('opentype');
        font-weight: 600;
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: 'Gilroy';
        src: url('/fonts/Gilroy-BoldItalic.otf') format('opentype');
        font-weight: Bold;
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: 'Gilroy';
        src: url('/fonts/Gilroy-ExtraBoldItalic.otf') format('opentype');
        font-weight: 800;
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: 'Gilroy';
        src: url('/fonts/Gilroy-MediumItalic.otf') format('opentype');
        font-weight: 500;
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: 'Gilroy';
        src: url('/fonts/Gilroy-LightItalic.otf') format('opentype');
        font-weight: 200;
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: 'Gilroy';
        src: url('/fonts/Gilroy-UltraLightItalic.otf') format('opentype');
        font-weight: lighter;
        font-style: italic;
        font-display: swap;
    }

    @font-face {
        font-family: 'Gilroy';
        src: url('/fonts/Gilroy-ThinItalic.otf') format('opentype');
        font-weight: 100;
        font-style: italic;
        font-display: swap;
    }
`;
export default GilroyFontFaces;
//# sourceMappingURL=Gilroy.js.map